export const SectionTitle = ({ children }) => {
    return (
        <div className="text-xl sm:text-3xl uppercase italic font-semibold p-4 sm:pb-8 rounded text-center text-white">
            {children}
        </div>
    )
}